<template>
  <div class="roll">
    <h1>SR5 Roll</h1>
    <div class="form">
      <div class="form-control">
        <label>
          Dices:
          <input type="number" min="0" v-model="formDices">
        </label>
      </div>
    </div>
    <h2 class="roll-preview" v-if="canRoll">
      <span>{{dices}}</span>
      <span>D</span>
      <span>{{sides}}</span>
    </h2>
    <div class="results" :class={glitched:isCriticalGlitch} v-if="hasRolls">
      <div class="summary">
        <span class="summary-hits" :class={passed:isPassed}>
          <div>Hits:</div>
          <div>{{hits}}</div>
        </span>
        <span class="summary-glitches" :class={glitched:glitches}>
          <div>Glitches:</div>
          <div>{{glitches}}</div>
        </span>
      </div>
      <div class="list" :class="{glitched:isGlitch}">
        <dice v-for="dice in rolls" :key="dice.hash" :dice="dice"/>
      </div>
    </div>
    <button
      class="roll-button"
      :class="{disabled:!canRoll}"
      :disabled="!canRoll"
      @click="throwDices()"
    >PRESS TO ROLL</button>
  </div>
</template>

<script>
import Dice from "@/components/Dice";
import { isHit, isGlitch } from "@/utils";

export default {
  name: "Roll",
  data() {
    return {
      formDices: "",
      sides: 6,
      rolls: []
    };
  },
  components: {
    dice: Dice
  },
  computed: {
    canRoll() {
      return this.dices > 0 && this.dices <= 200;
    },
    hasRolls() {
      return this.rolls.length > 0;
    },
    dices() {
      return this.parseFormDataNumber(this.formDices);
    },
    hits() {
      return this.rolls.filter(r => isHit(r)).length;
    },
    glitches() {
      return this.rolls.filter(r => isGlitch(r)).length;
    },
    isPassed() {
      return this.hits > 0;
    },
    isGlitch() {
      const rollsLength = this.rolls.length;
      return rollsLength > 0 && this.glitches >= rollsLength / 2;
    },
    isCriticalGlitch() {
      console.log("Is critical glitch?", !this.isPassed && this.isGlitch);
      return !this.isPassed && this.isGlitch;
    }
  },
  methods: {
    parseFormDataNumber(data) {
      return parseInt(data || "0", 10);
    },
    throwDices() {
      return (this.rolls = [...Array(this.dices).keys()].map(() => ({
        sides: this.sides,
        result: Math.ceil(Math.random() * this.sides),
        hash: this.makeRandomHash()
      })));
    },
    makeRandomHash() {
      const possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      return [...Array(this.sides + 1).keys()].reduce(
        text =>
          (text += possible.charAt(
            Math.floor(Math.random() * possible.length)
          )),
        ""
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

div.roll {
  margin-bottom: 65px;
  text-shadow: 2px 2px 2px black;
}

div.form {
  display: block;
}
div.form > div.form-control,
div.form > div.form-control-double {
  margin: 15px 0;
  font-size: 20px;
}
div.form input[type="number"],
div.form select {
  height: 40px;
  width: 80px;

  padding: 0 5px;
  margin: 0 5px;

  font-size: 18px;
  text-align: center;
}

div.form select {
  height: 44px;
  width: auto;
  margin: 0;
}

h2.roll-preview {
  display: flex;
  justify-content: center;
  align-content: center;
}
h2.roll-preview > span {
  padding: 0 3px;
}

div.results {
  margin: 10px;

  border: 1px solid black;
  border-radius: 4px;

  transition: box-shadow 0.2s;
}
div.results.glitched {
  box-shadow: 0px 0px 30px 50px #ff3d3d;
}
div.results > div.summary {
  display: flex;
  align-items: center;
  justify-content: space-around;

  height: 45px;
  border-bottom: 1px solid black;
}
div.results > div.summary > div {
  background-color: #303030;
  transition: background-color 0.2s;
}
div.results > div.summary > span {
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 18px;

  height: 100%;
  width: 100%;
}
div.results > div.summary > span > div {
  padding: 0 15px;
}
div.results > div.summary > span:first-child {
  border-right: 1px solid #313131;
}
div.results > div.summary > span.summary-hits {
  border-top-left-radius: 4px;
}
div.results > div.summary > span.summary-hits.passed {
  background-color: #3a4d3d;
}
div.results > div.summary > span.summary-glitches {
  border-top-right-radius: 4px;
}
div.results > div.summary > span.summary-glitches.glitched {
  background-color: #5a4646;
}
div.results > div.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  max-height: 500px;
  overflow-y: scroll;

  padding: 5px;

  -moz-box-shadow: inset 0 0 4px #000000;
  -webkit-box-shadow: inset 0 0 4px #000000;
  box-shadow: inset 0 0 4px #000000;

  transition: background-color 0.2s;
}
div.results > div.list.glitched {
  background-color: #dc3545;
}

button.roll-button {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 45px;

  outline: none;

  background-color: #313131;
  color: #cecece;

  font-weight: bold;

  transition: bottom 0.2s;
}
button.roll-button.disabled {
  bottom: -45px;
}

@media only screen and (min-width: 992px) {
  button.roll-button {
    width: 40%;
    left: 30%;
  }
  div.results > div.summary > span {
    font-size: 24px;
  }
  div.results > div.summary {
    height: 65px;
  }
}

@media only screen and (min-width: 1200px) {
  div.results > div.summary > span {
    font-size: 28px;
  }
  div.results > div.summary {
    height: 65px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Roll.vue